<div
  class="notifications-all"
  #notificationsContainer
>
  <div *ngIf="notifications.length > 0">
    <div class="d-flex justify-content-end mb-3 p-0">
      <base-button
        [disabled]="allNotificationsRead"
        [size]="buttonSize.sm"
        label="notification.markAllAsRead"
        color="secondary"
        (btnClick)="markAllAsRead()"
      ></base-button>
    </div>
    <base-notification-list-item
      *ngFor="let notification of notifications"
      [notification]="notification"
      (readNotification)="markNotificationAsRead($event.event, $event.notification)"
    ></base-notification-list-item>
  </div>

  <div *ngIf="notifications.length === 0 && isListLoaded">
    <base-empty-list-row
      message="notification.empty"
      [backgroundSecondary]="true"
    ></base-empty-list-row>
  </div>

  <base-pagination
    [page]="page"
    [size]="size"
    [itemsCount]="itemsCount"
    [noFilters]="true"
    (pageChange)="pageChanged($event)"
  ></base-pagination>
</div>
